import { Breakpoint, Dialog, DialogActions, DialogContent, Typography } from "@mui/material";
import { MprcCardHeaderColor } from "components";
import { ButtonClose } from "components/buttons";
import * as React from "react";
import { useEffect, useState } from "react";

//////////////////////////////////////////
interface IProps {
    title?: React.ReactNode;
    message: React.ReactNode;
    width?: Breakpoint;
    onClose: () => void;
}
//////////////////////////////////////////

export const MprcInformationDialog: React.FC<IProps> = (props) => {
    const { title, message, width = "md", onClose } = props;
    const [buttonRef, setButtonRef] = useState<HTMLButtonElement | null>(null);

    //////////////////////////////////////////

    useEffect(() => {
        buttonRef?.focus();
    }, [buttonRef]);

    //////////////////////////////////////////

    return (
        <Dialog open role="dialog" style={{ zIndex: 20001 }} fullWidth maxWidth={width} onClose={(e, reason) => reason == "escapeKeyDown" && onClose()}>
            {title && <MprcCardHeaderColor color="info" title={title} />}
            <DialogContent>
                <Typography variant="body1">{message}</Typography>
            </DialogContent>
            <DialogActions style={{ justifyContent: "center" }}>
                <ButtonClose ref={setButtonRef} onClick={() => props.onClose()} variant="contained" />
            </DialogActions>
        </Dialog>
    );
};
